module.exports = __webpack_public_path__ + "static/victor-9d07062fe16442044cef46d8cf186d69.jpg";